export default "__VITE_ASSET__BmKS8dix__"